module.exports = __webpack_public_path__ + "img/com (3).b9734cba.png";